import React from 'react';
import { RedocStandalone } from 'redoc';
import api from './api.json'
import Navbar from "../Navbar";
import Breadcumb from "../breadcumb";
import Newsletter from "../Newsletter";
import FooterSection from "../Footer";

const APIDocs = () => {
    return (
        <div>
           <Navbar/>
           <Breadcumb bdtitle={'API Documentation'} bdsub={'API'}/>
           {/* <Header
                parentMenu='pages'
                headerClass='sc-header-section inner-header-style'
                signUpBtn='inner-btn'
            />
            <BreadCums pageTitle='API Documentation' />*/}
           <RedocStandalone
              spec={api}
              options={{
                 generateCodeSamples: {
                    languages: [
                       { lang: 'curl' },
                       { lang: 'Node.js' },
                       { lang: 'JavaScript', label: 'JS' },
                       { lang: 'TypeScript', label: 'TS' }],
                    skipOptionalParameters: true,
                 },
                 disableSearch: true,
                 disableSidebar: true,
                 nativeScrollbars: true,
                 showExtensions:true,
                 showObjectSchemaExamples:true,
                 expandResponses:'all',
                 jsonSampleExpandLevel:'all',
                 theme: { colors: { primary: { main: '#F73741' } },
                    rightPanel: {
                       backgroundColor: '#001542'
                    }, },
              }}
              spec-Url='api.json'
              suppress-warnings='false'
              native-scrollbars='false'
              expand-responses='all'
              hide-hostname='false'
              scroll-y-offset='0'
              hide-loading='false'
              sort-properties-alphabetically='false'
              required-props-first='true'
              json-sample-expand-level='all'
              theme-color='#F64C72'
              hide-download-button='false'
              hide-single-request-sample-tab='false'
              show-extensions='true'
              allowed-unsafe-tags=''
           ></RedocStandalone>
           <Newsletter/>
           <FooterSection/>
        </div>
    );
};

export default APIDocs;
